<template>
  <div>
    <v-icon @click="abrirDialog" size="14" class="cursor-pointer">mdi-pencil</v-icon>

    <SysDialog
      v-model="dialog_ativo"
      titulo="Cobertura manual do estoque"
      :largura="!apenas_produto_selecionado ? 800 : 600"
      @click:primary="salvarCoberturaManual"
      @click:hidden-dialog="fecharDialog"
    >
      <v-radio-group v-model="apenas_produto_selecionado" v-if="!produto.produto_eh_combinacao">
        <v-radio :value="true">
          <template #label>
            <span class="ml-1">Aplicar apenas no produto selecionado</span>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template #label>
            <span class="ml-1">Aplicar através de filtros</span>
          </template>
        </v-radio>
      </v-radio-group>

      <DivisorComLegenda v-if="!apenas_produto_selecionado" legenda="Filtros" class="mb-5" />

      <BlocoFiltrosPrincipais v-show="!apenas_produto_selecionado" :filtros="filtros" ocultar_filtro_filiais />

      <DivisorComLegenda v-if="!apenas_produto_selecionado" legenda="Parâmetros" class="mb-5 mt-2" />

      <v-switch v-model="cobertura_manual_ativa">
        <template #label>
          <span class="ml-3">Ativar cobertura manual</span>
        </template>
      </v-switch>

      <TextFieldFormatadorDeValor
        v-model="qtde_dias_cobertura"
        label="Informe a quantidade de dias de cobertura"
        outlined
        inteiro
        clearable
        :disabled="!cobertura_manual_ativa"
        :error-messages="COBERTURA_ERROS"
        @focus="$event.target.select()"
        @keypress.enter="salvarCoberturaManual()"
      />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor";
import {required} from "vuelidate/lib/validators";
import {buscarCoberturaManualDeEstoque, salvarCoberturaManualDeEstoque} from "@/api/compraPorProdutosGerais/Produtos";
import {logout} from "@/helpers";
import BlocoFiltrosPrincipais from "@/components/compra/ProdutosGerais/Filtros/BlocoFiltrosPrincipais";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda";

export default {
  name: "CoberturaEstoqueManual",
  components: {
    DivisorComLegenda,
    BlocoFiltrosPrincipais,
    TextFieldFormatadorDeValor,
    SysDialog
  },
  props: {
    produto: Object
  },
  data: () => ({
    dialog_ativo: false,
    apenas_produto_selecionado: true,
    cobertura_manual_ativa: false,
    qtde_dias_cobertura: 0,
    qtde_dias_cobertura_atual: null,
    filtros: {
      grupos: [],
      segmentos: [],
      secoes: [],
      categorias: [],
      linhas: [],
      compradores: [],
      fornecedores: [],
      marcas: []
    }
  }),
  validations: {
    qtde_dias_cobertura: {
      required,
      minValue: function () {
        if (this.cobertura_manual_ativa) {
          return this.qtde_dias_cobertura >= 1;
        }

        return true;
      }
    }
  },
  computed: {
    COBERTURA_ERROS() {
      const errors = [];
      if (!this.$v.qtde_dias_cobertura.$dirty) return errors;
      !this.$v.qtde_dias_cobertura.required && errors.push("Campo Obrigatório.");
      !this.$v.qtde_dias_cobertura.minValue && errors.push("Insira um valor inteiro.");
      return errors;
    },
    FILTROS_STORE() {
      return this.$store.getters['CompraProdutosGerais/getFiltros'];
    }
  },
  watch: {
    apenas_produto_selecionado() {
      this.setFiltros();
    },
    cobertura_manual_ativa() {
      if (!this.cobertura_manual_ativa) {
        this.qtde_dias_cobertura = 0;
      } else {
        this.qtde_dias_cobertura = this.qtde_dias_cobertura_atual;
      }
    }
  },
  methods: {
    buscarCoberturaManualEstoque() {
      const parametros = {
        grupo: this.produto.id_grupo,
        produto: this.produto.id_produto,
      };

      this.$store.dispatch('loading/addRequisicao',
        buscarCoberturaManualDeEstoque(parametros)
          .then(cobertura => {
            this.cobertura_manual_ativa = cobertura.cobertura_manual_ativa;
            this.qtde_dias_cobertura = cobertura.qtde_dias_cobertura;
            this.qtde_dias_cobertura_atual = cobertura.qtde_dias_cobertura;
          })
          .catch(logout)
      );
    },
    salvarCoberturaManual() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        filtros: this.filtros,
        produto: this.produto.id_produto,
        qtde_dias_cobertura: parseInt(this.qtde_dias_cobertura),
        apenas_produto_selecionado: this.apenas_produto_selecionado,
        cobertura_manual_ativa: this.cobertura_manual_ativa,
        produto_eh_combinacao: this.produto.produto_eh_combinacao,
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarCoberturaManualDeEstoque(parametros)
          .then(() => {
            this.$emit("update:cobertura-manual-estoque", {});
            this.fecharDialog();
          })
          .catch(logout)
      );
    },
    abrirDialog() {
      this.dialog_ativo = ! this.dialog_ativo;
      this.setFiltros();
      this.buscarCoberturaManualEstoque();
    },
    setFiltros() {
      if (this.apenas_produto_selecionado) {
        this.filtros.grupos = [this.produto.id_grupo];
      } else {
        this.filtros.grupos = this.FILTROS_STORE.grupos;
        this.filtros.segmentos = this.FILTROS_STORE.segmentos;
        this.filtros.secoes = this.FILTROS_STORE.secoes;
        this.filtros.compradores = this.FILTROS_STORE.compradores;
        this.filtros.fornecedores = this.FILTROS_STORE.fornecedores;

      }
    },
    fecharDialog() {
      this.$v.$reset();
      this.dialog_ativo = false;
      this.apenas_produto_selecionado = true;
      this.cobertura_manual_ativa = false;
      this.qtde_dias_cobertura = 0;
    }
  }
}
</script>

<style scoped>

</style>
